if (!customElements.get('shop-the-look-products')) {
  class ShopTheLookProducts extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-stl-card]')];
      this.dots = [...this.querySelectorAll('[data-stl-dot]')];
      this.count = this.querySelector('[data-stl-count]');
      this.drawer = this.querySelector('.stl-products__drawer');
      this.trigger = this.querySelector('.stl-products__drawer-trigger');
      this.index = 0;

      this.addEventListener('click', (event) => {
        const dot = event.target.closest('[data-stl-dot]');
        if (dot && this.contains(dot)) {
          this.goTo(Number(dot.getAttribute('data-stl-dot')));
          return;
        }

        const dir = event.target.closest('[data-stl-dir]');
        if (dir && this.contains(dir)) {
          const next = dir.getAttribute('data-stl-dir') === 'next' ? this.index + 1 : this.index - 1;
          const last = this.slides.length - 1;
          this.goTo(next > last ? 0 : next < 0 ? last : next);
          return;
        }

        if (event.target.closest('.stl-products__drawer-trigger')) {
          this.setDrawer(true);
          return;
        }

        if (event.target.closest('[data-stl-close]')) {
          this.setDrawer(false);
        }
      });

      this.onKeydown = (event) => {
        if (event.key === 'Escape') this.setDrawer(false);
      };
      document.addEventListener('keydown', this.onKeydown);
      this.goTo(0);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      this.unlockScroll();
    }

    goTo(index) {
      if (!this.slides.length) return;
      this.index = index;
      this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      this.dots.forEach((dot, i) => {
        const current = i === index;
        dot.classList.toggle('is-current', current);
        if (current) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (this.count) this.count.textContent = (index + 1) + ' / ' + this.slides.length;
    }

    lockScroll() {
      if (this.scrollLocked) return;
      const gap = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.setProperty('--stl-scrollbar-gap', gap + 'px');
      document.documentElement.classList.add('stl-scroll-lock');
      this.scrollLocked = true;
    }

    unlockScroll() {
      if (!this.scrollLocked) return;
      this.scrollLocked = false;
      document.documentElement.classList.remove('stl-scroll-lock');
      document.documentElement.style.removeProperty('--stl-scrollbar-gap');
    }

    setDrawer(open) {
      if (!this.drawer) return;
      window.clearTimeout(this.drawerTimer);
      if (open) {
        this.lockScroll();
        this.drawer.classList.add('is-showing');
        this.drawer.offsetHeight;
        requestAnimationFrame(() => {
          this.drawer.classList.add('is-open');
          this.drawer.setAttribute('aria-hidden', 'false');
          if (this.trigger) this.trigger.setAttribute('aria-expanded', 'true');
        });
        return;
      }

      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      if (this.trigger) this.trigger.setAttribute('aria-expanded', 'false');
      this.drawerTimer = window.setTimeout(() => {
        if (!this.drawer.classList.contains('is-open')) {
          this.drawer.classList.remove('is-showing');
          this.unlockScroll();
        }
      }, 300);
    }
  }

  customElements.define('shop-the-look-products', ShopTheLookProducts);
}
